var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { QualificationRoomType } from '@shared/types/api/claim';
import { INSURER_CONFIG } from '@shared/insurer';
let HouseCrossSection = class HouseCrossSection extends Vue {
    constructor() {
        var _a, _b, _c, _d, _e;
        super(...arguments);
        this.RoomType = QualificationRoomType;
        this.customConfig = ((_e = (_d = (_c = (_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.roomDamagesContents) === null || _b === void 0 ? void 0 : _b.housingConfigurationByHousingType) === null || _c === void 0 ? void 0 : _c.house) === null || _d === void 0 ? void 0 : _d.selectedRoomsMapping) === null || _e === void 0 ? void 0 : _e.insideHouse) || null;
    }
    leakageLocation(location) {
        var _a;
        return ((_a = this.customConfig) === null || _a === void 0 ? void 0 : _a[location]) || location;
    }
};
HouseCrossSection = __decorate([
    Component({
        props: {
            selectedRoom: {
                type: String,
                default: null,
            },
            hoveredRoom: {
                type: String,
                default: null,
            },
        },
    })
], HouseCrossSection);
export default HouseCrossSection;
